import { rfqJobQuoteDetailsPageContainerStyles } from "@insite/content-library/Widgets/RfqJobQuoteDetails/RfqJobQuoteDetailsPageContainer";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

rfqJobQuoteDetailsPageContainerStyles.mainContainer = {
    offsetCss: css`
    ${({ theme }) => {
            return breakpointMediaQueries(theme, [
                css`
                    margin : 0px;
                `,
                css`
                    margin : 0px;
                `,
                null,
                null,
                null
            ]);
        }}
    `
}

rfqJobQuoteDetailsPageContainerStyles.topGridItem = {
    width: 12,
    css: css`
    ${({ theme }) => {
        return breakpointMediaQueries(theme, [
            css`
                padding : 0px;
            `,
            css`
                padding : 0px;
            `,
            null,
            null,
            null
        ]);
    }}
    `
}
rfqJobQuoteDetailsPageContainerStyles.middleGridItem = {
    width: 12,
    css: css`
    ${({ theme }) => {
        return breakpointMediaQueries(theme, [
            css`
                padding : 0px;
            `,
            css`
                padding : 0px;
            `,
            null,
            null,
            null
        ]);
    }}
    `
}